import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useApiGetKsPeriodikList } from 'api/kinerja/kepala-sekolah/dinas/penilaian-periodik'
import { Header } from 'app/KinerjaShared/components/Header'
import { HeaderPanelBase } from 'app/KinerjaShared/components/HeaderPanelBase'
import { TablePeriodik } from 'app/KinerjaShared/components/Periodik/TablePeriodik'
import { PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH } from 'app/KinerjaShared/constants/path'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useSafeBackNavigation } from 'app/KinerjaShared/hooks/useSafeBackNavigation'
import { PANDUAN_PENILAIAN_PERIODIK_GPK_URL } from 'app/KinerjaShared/utils/panduan'

export function DaftarPenilaianPeriodik() {
  const { periodYear } = usePeriodContext()

  // ---------------------------
  // Get periodic list
  // ---------------------------
  const { data, isLoading } = useApiGetKsPeriodikList({
    params: { skpYear: periodYear, tipe: 'GPK' },
    options: {
      enabled: Number.isInteger(periodYear),
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })

  const items = data?.data?.periods ?? []

  // -----------------------------------------
  // Handle guard back navigation for unsaved changes
  // -----------------------------------------
  const { handleBack } = useSafeBackNavigation({
    fallbackRoute: PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH,
  })

  return (
    <div className="px-8 pb-8 pt-12 bg-gray-10 min-h-full">
      <div className="max-w-6xl mx-auto pb-12">
        <Header
          title="Penilaian Periodik"
          className="mb-12"
          rightNode={
            <HeaderPanelBase>
              <a
                className="flex items-center space-x-1 text-blue-70"
                href={PANDUAN_PENILAIAN_PERIODIK_GPK_URL}
                target="_blank"
                rel="noreferrer"
              >
                <Icon color="inherit">help</Icon>
                <Text as="span" variant="action" color="inherit">
                  Cek Pusat Informasi
                </Text>
              </a>
            </HeaderPanelBase>
          }
          onBack={handleBack}
        />

        <main>
          <div className="p-4 mb-8 bg-cyan-5 border border-blue-70 rounded gap-2 flex mt-6">
            <Icon>info</Icon>
            <Text>
              Data Penilaian Periodik untuk periode sebelumnya sudah tersedia
              dan hanya dapat dicek di E-Kinerja.
            </Text>
          </div>
          <TablePeriodik
            isLoading={isLoading}
            items={items}
            showAutosendColumn
            nextPageResolver={(month) =>
              `${PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH}/periodik/${month}`
            }
          />
        </main>
      </div>
    </div>
  )
}
